export interface FieldConfig {
  id: string
  fieldType: 'text' | 'dropdown' | 'datepicker' | 'datetimepicker' | 'timepicker'
  title: string
  isRequired: boolean
  index: number

  fieldName?: string
  isRequiredError?: string
  regex?: string
  regexError?: string
  defaultValue?: string
  maxLength: number
  values?: string
  value?: string | Date | null // current value
  hint?: string
}

export interface FieldConfigRaw {
  index: number,
  id: number,
  values: { [key: string]: string }
}


export function normalizeFieldsConfigs(fieldsObj: FieldConfigRaw[]): FieldConfig[] {
  return fieldsObj.map(raw => {

    const result = raw.values as any
    result.id = raw.id.toString()
    result.index = raw.index

    result.fieldType = result.fieldType?.toLowerCase()
    result.isRequired = typeof result.isRequired === 'string' && result.isRequired.toLowerCase() === 'true'
    result.maxLength = typeof result.maxLength === 'string' ? +result.maxLength : 1000

    return result as FieldConfig
  }).sort((a, b) => a.index > b.index ? 1 : -1)
}
